import { useState } from "react";
import "./editorialForms.css";

const yogaStyles = [
  { id: "hatha", name: "Hatha Yoga" },
  { id: "vinyasa", name: "Vinyasa Flow" },
  { id: "ashtanga", name: "Ashtanga" },
  { id: "bikram", name: "Bikram (Hot Yoga)" },
  { id: "yin", name: "Yin Yoga" },
  { id: "restorative", name: "Restaurativo" },
  { id: "kundalini", name: "Kundalini" },
  { id: "power", name: "Power Yoga" },
  { id: "prenatal", name: "Yoga para Gestantes" },
  { id: "kids", name: "Yoga Infantil" },
];

const levels = [
  { id: "beginner", name: "Iniciante" },
  { id: "intermediate", name: "Intermediário" },
  { id: "advanced", name: "Avançado" },
  { id: "all_levels", name: "Todos os níveis" },
];

export default function YogaForm({ data, onChange }) {
  const [focusInput, setFocusInput] = useState("");
  const [benefitInput, setBenefitInput] = useState("");

  const handleAddFocus = () => {
    if (focusInput.trim()) {
      onChange({
        ...data,
        focusAreas: [...(data?.focusAreas || []), focusInput.trim()],
      });
      setFocusInput("");
    }
  };

  const handleRemoveFocus = (index) => {
    onChange({
      ...data,
      focusAreas: (data?.focusAreas || []).filter((_, i) => i !== index),
    });
  };

  const handleAddBenefit = () => {
    if (benefitInput.trim()) {
      onChange({
        ...data,
        benefits: [...(data?.benefits || []), benefitInput.trim()],
      });
      setBenefitInput("");
    }
  };

  const handleRemoveBenefit = (index) => {
    onChange({
      ...data,
      benefits: (data?.benefits || []).filter((_, i) => i !== index),
    });
  };

  const commonEquipment = [
    "Tapete de Yoga",
    "Bloco",
    "Cinta/Faixa",
    "Bolster",
    "Cobertor",
    "Roda de Yoga",
  ];

  const handleToggleEquipment = (item) => {
    const current = data?.equipment || [];
    if (current.includes(item)) {
      onChange({
        ...data,
        equipment: current.filter((e) => e !== item),
      });
    } else {
      onChange({
        ...data,
        equipment: [...current, item],
      });
    }
  };

  return (
    <div className="editorial_form yoga_form">
      <div className="editorial_form_section">
        <label>
          Título da Aula/Prática <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Vinyasa Flow para Flexibilidade"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descreva a prática, o que esperar, para quem é indicada..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={1000}
          rows={3}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>
            Estilo de Yoga <span className="required">*</span>
          </label>
          <select
            value={data?.yogaStyle || ""}
            onChange={(e) => onChange({ ...data, yogaStyle: e.target.value })}
          >
            <option value="">Selecione</option>
            {yogaStyles.map((style) => (
              <option key={style.id} value={style.id}>
                {style.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Nível</label>
          <select
            value={data?.level || ""}
            onChange={(e) => onChange({ ...data, level: e.target.value })}
          >
            <option value="">Selecione</option>
            {levels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Duração (min)</label>
          <input
            type="number"
            placeholder="60"
            value={data?.duration || ""}
            onChange={(e) =>
              onChange({ ...data, duration: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <label>Instrutor(a)</label>
          <input
            type="text"
            placeholder="Nome do instrutor(a)"
            value={data?.instructor || ""}
            onChange={(e) => onChange({ ...data, instructor: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Equipamentos Necessários</label>
        <div className="genre_chips">
          {commonEquipment.map((item) => (
            <span
              key={item}
              className={`genre_chip ${
                (data?.equipment || []).includes(item) ? "selected" : ""
              }`}
              onClick={() => handleToggleEquipment(item)}
            >
              {item}
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Áreas de Foco
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddFocus}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: Quadril, Ombros, Core, Respiração..."
          value={focusInput}
          onChange={(e) => setFocusInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddFocus()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.focusAreas || []).map((area, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveFocus(i)}
              style={{ cursor: "pointer" }}
            >
              {area} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Benefícios
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddBenefit}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: Reduz stress, Melhora postura, Aumenta flexibilidade..."
          value={benefitInput}
          onChange={(e) => setBenefitInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddBenefit()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.benefits || []).map((benefit, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveBenefit(i)}
              style={{ cursor: "pointer" }}
            >
              {benefit} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isLive"
            checked={data?.isLive || false}
            onChange={(e) => onChange({ ...data, isLive: e.target.checked })}
          />
          <label htmlFor="isLive">Aula ao vivo</label>
        </div>
      </div>

      {data?.isLive && (
        <div className="editorial_form_section">
          <label>Data e Hora da Aula</label>
          <input
            type="datetime-local"
            value={data?.scheduledAt?.slice(0, 16) || ""}
            onChange={(e) =>
              onChange({
                ...data,
                scheduledAt: new Date(e.target.value).toISOString(),
              })
            }
          />
        </div>
      )}

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
        <span>
          Adicione um vídeo demonstrativo para melhor engajamento!
        </span>
      </div>
    </div>
  );
}
